import { Paper, Typography } from '@mui/material';
import React from 'react';

import useReferenceRange from '@hooks/useReferenceRange';

import type { ReferenceRangeRiskLevel } from 'generated/types';

import { FontWeight } from '../../../../theme/typography';

interface LikelihoodCardProps {
  title: string;
  subtitle?: string;
  level: ReferenceRangeRiskLevel;
}

export default function LikelihoodCard({
  level,
  subtitle,
  title,
}: LikelihoodCardProps) {
  const { parameterMap } = useReferenceRange();
  const { bgColour, colour } = parameterMap[level];

  const typographyStyling = {
    fontWeight: FontWeight.Light,
  };

  return (
    <Paper
      sx={{
        backgroundColor: bgColour,
        border: `1px solid ${colour}`,
        p: 1,
        borderRadius: 1,
      }}
      elevation={0}
    >
      <Typography
        variant="h6"
        lineHeight="100%"
        fontSize={14}
        sx={{
          ...typographyStyling,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          color="text.secondary"
          variant="caption"
          sx={{ ...typographyStyling }}
        >
          {subtitle}
        </Typography>
      )}
    </Paper>
  );
}
